let sliderItems = document.querySelectorAll(".image_with_content_slider .image_with_content_slider_main_list");
if (sliderItems) {
    sliderItems.forEach(element => {
        let sliderItemsChild = element.childNodes.length;
        let dotsParent = element.closest(".image_with_content_slider");
        let dotsDiv = "";
        let prevArrow = "";
        let nextArrow = "";
        if (dotsParent) {
            dotsDiv = dotsParent.querySelector(".slider_controls .slider_dots");
            prevArrow = dotsParent.querySelector(".slider_controls .prev_arrow");
            nextArrow = dotsParent.querySelector(".slider_controls .next_arrow");
        }
        if (sliderItemsChild > 1) {
            jQuery(element).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                infinite: true,
                appendDots: dotsDiv,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                autoplay: true,
                autoplaySpeed: 4000,
            })
        }
    });
}